import * as React from "react";
import { ContentEvaluationModel } from "../../model/content-evaluation-model";
import { EvaluationFinding } from "./EvaluationFinding";

export const FindingsList: React.FC<ContentEvaluationModel.FindingsListProps> = ({ findings }) => {
    if (!findings || findings.length === 0) {
        return null;
    }

    return (
        <div>
            <h3 style={{
                color: "#374151",
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "16px",
                borderBottom: "2px solid #e5e7eb",
                paddingBottom: "8px"
            }}>
                Detailed Findings:
            </h3>
            {findings.map((finding, index) => (
                <EvaluationFinding
                    key={index}
                    finding={finding}
                    index={index}
                />
            ))}
        </div>
    );
};
